<app-shared-layout
  [Analysis]="title"
  [hideAdd]="false"
  [addPermission]="addPermission"
  addButtonName="{{ 'Create Subscription' }}"
  (addItem)="onAdd()"
>

  <div ngProjectAs="primary-panel">

    <app-data-table-pageable
      [tableActions]="tableActions"
      [tableColumns]="tableColumns"
      [query]="query"
      [upsertAction]="upsertAction"
      [deleteAction]="deleteAction"
      [additionalVariables]="additionalVariables"
      (btnClicked)="btnClicked($event)"
      [storeEntity] = "storeEntity"
    >
    </app-data-table-pageable>

  </div>

  <div ngProjectAs="secondary-panel" *ngIf="viewDetails">
    <div class="p-4">
      <h3>{{ viewDetailsTitle }}</h3>
      <button mat-raised-button color="primary" (click)="closePanel()">Close</button>
    </div>
  </div>

</app-shared-layout>
